// extracted by mini-css-extract-plugin
export default {"button":"backButtonStyle_button__j7nns","small":"backButtonStyle_small__BVUto"};